import { useCallback } from 'react'

import { useStoreDetails } from './useStoreDetails'

export function useStorePathBuilder() {
  const store = useStoreDetails()

  const builder = useCallback((path: string) => {
    const isDevEnv = Boolean(process.env.NODE_ENV === 'development')
    const isPreviewEnv = Boolean(
      process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
    )
    const isStagingEnv = Boolean(
      process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF === 'staging'
    )

    const pathTo = path.startsWith('/') ? path.slice(1) : path

    return isDevEnv || (!isStagingEnv && isPreviewEnv)
      ? `/${store?.domain}/${pathTo}`
      : `/${pathTo}`
  }, [store])

  return builder
}
